import { BaseService } from './base.service';

export interface PurchaseHistoryItem {
  id: string;
  familyId: string;
  planId: string;
  startDate: string;
  endDate: string;
  status: string;
  amount?: number;
  currency?: string;
  createdAt: string;
  updatedAt: string;
  plan?: {
    id: string;
    name: string;
    type: string;
  };
}
import type { Plan, FamilySubscription, PurchaseHistoryResponse } from '@/types/subscription';

export class SubscriptionService extends BaseService {
  constructor() {
    super('/member-subscriptions');
  }

  async getPlans(): Promise<Plan[]> {
    return this.get<Plan[]>('');
  }

  async getPublicPlans(): Promise<Plan[]> {
    // Use api directly for public endpoint that doesn't require auth
    const api = await import('./api');
    const response = await api.default.get('/plans-public');
    return response.data;
  }

  async getCurrentSubscription(): Promise<FamilySubscription> {
    return this.get<FamilySubscription>('/current');
  }

  async subscribe(planId: string): Promise<FamilySubscription> {
    return this.post<FamilySubscription>('', { planId });
  }

  async cancelSubscription(): Promise<{ success: boolean }> {
    return this.post<{ success: boolean }>('/cancel');
  }

  async getPurchaseHistory(payload: any): Promise<PurchaseHistoryResponse> {
    // Use api directly for different endpoint
    const api = await import('./api');
    const response = await api.default.post('/family-subscriptions-history/all', payload);
    return response.data;
  }
}

export const subscriptionService = new SubscriptionService();
